<div class="work-ui-secret-reveal">
  <div (click)="toggleReveal()" [style.width]="containerWidth" class="value-container">
    <span [ngClass]="{ 'revealed': isRevealed }" class="value">
      {{ isRevealed ? value : obfuscatedValue }}
    </span>
  </div>
</div>
